import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

//首页轮播图 首页品牌馆
export function getConfigurationItemList(query) {
  return request({
    url: BASEROOT + '/configurationItem/visitor/getConfigurationItemList',
    method: 'post',
    data: query
  })
}

// 首页 推荐展品
export function getRecommendProductList(query) {
  return request({
    // url: BASEROOT + '/productRecommend/visitor/recommendProductList',
    url: BASEROOT + '/product/browse/all/list',
    method: 'post',
    data: query
  })
}

// 首页 直播列表
export function getQueryList(query) {
  return request({
    url: BASEROOT + '/live/queryList',
    method: 'post',
    data: query
  })
}

// 首页 直播
export function getQueryDetail(query) {
  return request({
    url: BASEROOT + '/live/queryDetail',
    method: 'post',
    data: query
  })
}






